// LEGACY CV export flow (SP-12046): do not modify, do not import outside index.ts.
// Remove with the cv_export_legacy_flow feature flag.
import { LazyLocalExportTrigger } from "./lazy_local_export_trigger";
import { GetProfilesCollection } from "./local_export_trigger.types";

/** @deprecated Legacy CV export flow (cv_export_legacy_flow). Do not use or modify. Remove with the flag. */
export const LegacyLazyLocalExportTrigger = LazyLocalExportTrigger;

/** @deprecated Legacy CV export flow (cv_export_legacy_flow). Do not use or modify. Remove with the flag. */
export type LegacyGetProfilesCollection = GetProfilesCollection;
